import * as React from 'react';
import * as style from '../MainPage.css';
import { StepsTileContainer } from '../../StepsTile';
import { Questions } from '../../Questions';
import { BreadcrumbsContainer } from '../../Breadcrumbs';
import { IMainPageContent } from '../../../types/helper';
import { PictureVasyaTablet } from '../picture/vasya-tablet';
import { PictureBoxTablet } from '../picture/box-tablet';
import { PictureCatTablet } from '../picture/cat-tablet';
import { clickAskProfessional } from '../../../utils/events';

interface IMainViewTablet {
    content: IMainPageContent;
}

export const ViewTablet = (props: IMainViewTablet) => {
  // tslint:disable:max-line-length
  return (
    <React.Fragment>
      <div className={style['body']}>
        <div>
          <BreadcrumbsContainer />
          <div className={style['title']}>
            {props.content && props.content.title}
          </div>
          <div className={style['description']}>
            {props.content && props.content.body}
          </div>
        </div>
        <div className={style['picture']}>
          <PictureVasyaTablet width={262} height={245} />
        </div>
      </div>
      <div className={style['container']}>
        <StepsTileContainer />
        <Questions />
      </div>
      <div className={style['footer_container']}>
        <div className={style['picture_box']}><PictureBoxTablet /></div>
        <div className={style['footer_body']}>
          <div className={style['footer_title']}>Не нашли нужной вам информации?</div>
          <a onClick={clickAskProfessional} href="https://www.cian.ru/add-vopros/">
            Спросите у профессионала
          </a>
          <br />
          или <a href="https://docs.google.com/forms/u/1/d/e/1FAIpQLSchgoXzaxnvx5obzuLB9cyucYPhha1KKvGsky-aX-TmZybndQ/viewform">оставьте отзыв о Помощнике</a>
        </div>
        <div className={style['picture_cat']}><PictureCatTablet /></div>
      </div>
    </React.Fragment>
  );
};
